'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.actions = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = require('redux-actions');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
  {
    type: 'setOptions',
    payload: {
      reference: 'customers',
      options: options,
      updatedAt: new Date(),
    }
  }
  */
var setOptions = (0, _reduxActions.createAction)('setOptions');
var actions = { setOptions: setOptions };

/**
  dropdowns: {
    customers: {
      options: [...options],
      updatedAt: Date,
    },
  }
  */
var reducer = (0, _reduxActions.handleAction)(setOptions,
// TODO partial update options
function (state, _ref) {
  var _ref$payload = _ref.payload,
      reference = _ref$payload.reference,
      options = _ref$payload.options,
      timestamp = _ref$payload.timestamp;
  return _extends({}, state, _defineProperty({}, reference, {
    options: options,
    updatedAt: timestamp
  }));
}, {});

exports.actions = actions;
exports.reducer = reducer;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/enhancers/processOptions/dropdowns.js
// module id = 1111
// module chunks = 0